import { TOKEN_NAME } from '../../utils/constants';
import cookies from '../../utils/cookies';

const getToken = () => cookies.get(TOKEN_NAME);

export default {
  getToken,
};
